import "../style.css"
import "../src/gravity-forms.scss"
import "../src/styles.scss"
import "../src/media-queries.scss"
import "../js/functions.js"

import Tabs from "./components/tabs.svelte"
import BigPicture from "./bigpicture"

const { jQuery: $ } = window

const $body = $(document.body)
const $capabilities = $("#capabilities")

if ($capabilities.length) {
  new Tabs({
    target: $(".entry-content")[0],
    props: {
      capabilities: $capabilities.data("capabilities")
    }
  })
}

const $galleryContainer = $("#gallery-container")

if ($galleryContainer.length) {
  let $elAnchors = $(".blocks-gallery-item a")

  $elAnchors.on("click", function(e) {
    e.preventDefault()
    BigPicture({
      el: e.currentTarget,
      gallery: "#gallery-container",
      attribute: "href"
    })
  })
}

// class to hide outlines if not using keyboard
$body.on("mousedown", function() {
  $body.addClass("using-mouse")
})
$body.on("keydown", function() {
  $body.removeClass("using-mouse")
})
